export {
  LandingPageCustom,
  type LandingPageCustomProps,
} from './LandingPageCustom';
export { landingPageCustomSchema } from './schema';
